import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { vendorLayoutRoute } from 'features/vendors/VendorLayout';

export const vendorOfferingsRoute = createRoute({
  getParentRoute: () => vendorLayoutRoute,
  path: 'offerings',
  component: lazyRouteComponent(() => import('./VendorOfferingsView')),
  validateSearch: z.object({
    create: z.boolean().optional(),
    page: z.coerce.number().optional(),
    search: z.coerce.string().optional(),
    statuses: z.array(z.string()).optional(),
    updatedFrom: z.string().optional(),
    updatedTo: z.string().optional(),
    offering: z.string().optional(),
    editOfferingDetails: z.string().optional(),
    editOfferingCost: z.string().optional(),
    scheduledCosts: z.boolean().optional(),
    pastScheduledCostsWindow: z.coerce.number().optional(),
    futureScheduledCostsWindow: z.coerce.number().optional(),
    linkProduct: z.string().optional(),
    delist: z.string().optional(),
  }).parse,
});
